import { initialState } from "./slice";
import { createSelector } from "reselect";

export const selectPdfDetectedField = (state) =>
  state.pdfDetectedField || initialState;

export const selectEntities = createSelector(
  selectPdfDetectedField,
  (pdfDetectedFieldState) => pdfDetectedFieldState.entities
);

export const selectIds = createSelector(
  selectPdfDetectedField,
  (pdfDetectedFieldState) => pdfDetectedFieldState.ids
);

export const selectPdfDetectedFields = createSelector(
  selectEntities,
  selectIds,
  (entities, ids) => ids.map((id) => entities[id])
);

export const selectIsShown = createSelector(
  selectPdfDetectedField,
  (pdfDetectedFieldState) => pdfDetectedFieldState.isShown
);

